export default class Store {
  models = {};
  add(type, model) {
    this.models[type] = model;
    return this;
  }
  extend(app, extension) {
    for (const type in this.models) {
      if (app.store.models[type]) {
        throw new Error(`The model type "${type}" has already been registered with the class "${app.store.models[type].name}".`);
      }
      app.store.models[type] = this.models[type];
    }
  }
}
flarum.reg.add('core', 'common/extenders/Store', Store);